<template>
  <div class="banner">
    <a-icon type="left-circle" @click="nextPrev('prev')" />
    <a-carousel autoplay ref="Carousel">
      <div @click="submit(item)" class="carousel_whole" v-for="(item,index) in bannerList" :key="index"> <img :src="item.src"> </div>
    </a-carousel>
    <a-icon type="right-circle" @click="nextPrev('next')" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      bannerList: []
    }
  },
  created() {
    this.setBanner();
  },
  methods: {
    nextPrev(key = null) {
      key && this.$refs.Carousel[key]();
    },
    submit({ url = null, router = null, skipKey = null }) {
      let fn = () => {
        router && this.$router.$push(router);
        url && this.$router.$push({ path: "container", query: { url } });
      };
      if (router == "/standardList/item") {
        skipKey && this.$FN.limitsTips({ list: [skipKey], tips: false }).then(res => res ? fn() : (this.reveal = !res));
      } else {
        skipKey && this.$FN.limitsTips({ list: [skipKey] }).then(res => {
          if (res) fn();
        });
      };
    },
    setBanner() {
      let list = [
        {
          src: require(`@/assets/images/banner/banner1.png`),
          router: "/standardList/item",
          rolesKey: "home_banner_standardList_view",
          skipKey: "home_banner_standardList_skip"
        },
        {
          src: require(`@/assets/images/banner/banner2.png`),
          router: "/digitization",
          rolesKey: "home_banner_digitization_view",
          skipKey: "home_banner_digitization_skip"
        },
        {
          src: require(`@/assets/images/banner/banner3.png`),
          router: "/ceppeaPublish",
          rolesKey: "home_banner_standards_view",
          skipKey: "home_banner_standards_skip"
        },
        {
          src: require(`@/assets/images/banner/banner4.png`),
          router: "/standardTranslation",
          rolesKey: "home_banner_standardTranslation_view",
          skipKey: "home_banner_standardTranslation_skip"
        },
        {
          src: require(`@/assets/images/banner/banner5.png`),
          router: "/technicalRegulations",
          rolesKey: "home_banner_technicalRegulations_view",
          skipKey: "home_banner_technicalRegulations_skip"
        },
        {
          src: require(`@/assets/images/banner/banner6.png`),
          rolesKey: "home_banner_pesData_view"
        },
      ];
      this.bannerList = this.$FN.filterLimitsVisible({ data: list });
    },
  }
}
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>